

































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { Machine, interpret } from 'xstate';
import { AxiosError } from 'axios';

import { CommentQueryParametersInterface } from "@api/repositories/interfaces/CommentQueryParametersInterface";
import { UserProfile } from "@api/models/UserProfile";
import { Comment } from "@api/models/comments/Comment";
import { CommentsBlock } from '@api/models/comments/CommentsBlock';
import {Form} from "@api/models/Form";
import {EventMembership} from "@api/models/EventMemberShip";
import { CommentAttachment, CommentAttachmentType } from "@api/enums/CommentTypes";
import {Popup} from '@api/models/Popup';

import { RepositoryFabric } from "@api/repositories/RepositoryFabric";
import { CommentRepository } from "@api/repositories/CommentRepository";
import { CommentViewModes } from "@api/enums/CommentViewModes";
import { UserRepository } from "@api/repositories/UserRepository";
import { FormsRepository } from "@api/repositories/FormsRepository";
import { ObjectRepository } from "@api/repositories/ObjectRepository";
import { SignalRMethod, RealtimeCallback } from "@api/repositories/reatime-repository/types";
import {RealtimeRepository} from "@api/repositories/reatime-repository/RealtimeRepository";

import CommentView from "./Comment.vue";
import CommentTextarea from "./CommentTextarea.vue"
import CloseBtn from '@share/common/CloseBtn.vue';
import FormSelector from "./FormSelector.vue";
import PeriodicRefreshMixin from "@mixins/PeriodicRefreshMixin";
import BounceSpinner from "@share/common/BounceSpinner.vue";
import BannerLink from "@share/common/BannerLink.vue";
import ToggleButton from "@common/vue-toggle-btn/toggle-btn.vue";

import { ArrayHelpers } from "@common/ArrayHelpers";
import {groupFilter} from "@api/helpers/groupFilter";
import {Debounce} from "vue-debounce-decorator";
import {detectMob} from "@common/mobileHelper";
import {controlMessages} from '../data/controlMessages';
import Debug from "debug";
import {Modal} from "@common/Modal";
import { DynamicScroller, DynamicScrollerItem, RecycleScroller } from 'vue-virtual-scroller'
import {
    CommentUpdate,
    CommentUpdateMessage
} from "@share/comments/type/CommentUpdatedMessage";
import {parseCommentUpdates} from "@share/comments/helpers/CommentsUpdateParser";
import {UserProfileInterface} from "@api/models/interfaces/UserProfileInterface";
import { parseJson } from '@common/TypesHelper';
import {commentSortingValue} from "@share/comments/helpers/CommentSortingValue";
import {isCommentPublished} from "@share/comments/helpers/IsPublishedHelper";
import { getTranslateY } from "@common/stylesHelper";

import AttachSvg from "../../../assets/svg/attach.svg"

const debug = Debug("comments");

@Component({
    name: "CommentsView",
    components: { ToggleButton, CommentView, CloseBtn, FormSelector, CommentTextarea, BounceSpinner, BannerLink, DynamicScroller, DynamicScrollerItem, AttachSvg },
    mixins: [ PeriodicRefreshMixin ]
})
export default class CommentsView extends PeriodicRefreshMixin implements EventListenerObject {
    static AUTOUPDATE_DELAY = 5000;
    static AUTOUPDATE_DELAY_LIVE = 3000;
    static MIN_TIME = '2001-01-01 00:00:00';
    static CLOSE_LIVE_SESSION_MESSAGE = controlMessages.CLOSE_LIVE_SESSION_MESSAGE;
    static CHANGE_LIVE_SESSION_MESSAGE = controlMessages.CHANGE_LIVE_SESSION_MESSAGE;
    static MIN_OFFSET_FOR_AUTOSCROLLING = 70;

    @Prop({required: true}) objectId: string;
    @Prop({required: true}) schemaId: string;
    @Prop({required: false}) isLive: boolean;

    //USELESS: isShowFilter
    @Prop({required: false, default: false}) isShowFilter: boolean;
    @Prop({required: false, default: true}) isShowTitle: boolean;
    @Prop({required: false, default: () => []}) speakers: EventMembership[];
    @Prop({ default: true }) showHeader: boolean;
    @Prop({ default: null }) title: string | null;
    @Prop({ default: () => [] }) filterByUsers: number[];

    commentRepository: CommentRepository;
    userRepository: UserRepository;
    formRepository: FormsRepository;
    realtimeRepository: RealtimeRepository;
    objectRepository: ObjectRepository;

    isSending = false;
    autoupdateDelay = CommentsView.AUTOUPDATE_DELAY;
    comments: Comment[] = [];
    commentsAfter = 0;
    commentsBefore = 0;
    commentators: Record<string, UserProfile> = {};
    message = '';
    commentIdToAnswer = '';
    threadIdToAnswer = '';
    userIdToAnswer = '';
    lastUpdatedAt = CommentsView.MIN_TIME;
    forms: Form[] = [];
    viewMode: CommentViewModes = CommentViewModes.all;
    CommentViewModes = CommentViewModes;
    isShowAnswerPanel = true;
    isShowPollsPanel = false;
    pinnedComment: Comment | '' = '';
    editedComment: Comment | null = null
    isChangingPinnedComment = false;
    scrollState = { top: 0, scrolledUp: 0, needScrollBottom: false, height: 0};
    error = false;
    useRealtimeUpdates = true;
    commentsUpdateCallback: RealtimeCallback | null = null;

    toggleOptions = {
        handle: {
            diameter: 17,
            distance: 40
        },
        track : {
            activeColor: "#4CD964",
            width: 32,
            height: 19
        }
    }

    finiteStateMachine = Machine({
        id: 'comments',
        initial: 'init',
        states: {
            init: {
                on: {
                    LOAD: 'loading'
                }
            },
            initError: {
                on: {
                    LOAD: 'loading'
                }
            },
            loading: {
                entry: ['clearError'],
                invoke: {
                    id: 'loading',
                    src: () => {
                        return this.refreshComments();
                    },
                    onDone: {
                        target: 'idle',
                        actions: ['notifyLoaded']
                    },
                    onError: {
                        target: 'initError',
                        actions: ['retryOnError']
                    }
                }
            },
            idle: {
                on: {
                    REFRESH: 'refreshing'
                }
            },
            refreshing: {
                invoke: {
                    id: 'refreshing',
                    src: () => {
                        return this.refreshComments();
                    },
                    onDone: {
                        target: 'idle'
                    },
                    onError: {
                        target: 'idle'
                    }
                }
            }
        }
    },
    {
        actions: {
            notifyLoaded: () => {
                if (this.isLive) {
                    this.scrollCommentsToBottom();
                }
                //кол-во пикселей проскроленных снизу вверх
                if((this.$refs['body'] as Vue | undefined)?.$el) {
                    this.scrollState.scrolledUp = (this.$refs['body'] as Vue).$el.children[0].clientHeight;
                }
            },
            retryOnError: () => {
                this.setError(true);
                setTimeout(() => { this.do('LOAD') }, this.autoupdateDelay)
            },
            clearError: () => {
                this.setError(false);
            }
        }
    });
    commentStates = interpret(this.finiteStateMachine).start();

    // Vue hooks
    async created() {
        this.commentRepository = this.$repositories.get(RepositoryFabric.COMMENT);
        this.userRepository = this.$repositories.get(RepositoryFabric.USER);
        this.formRepository = this.$repositories.get(RepositoryFabric.FORM);
        this.realtimeRepository = this.$repositories.get(RepositoryFabric.REALTIME);
        this.objectRepository = this.$repositories.get(RepositoryFabric.OBJECT);
        if (this.isAdmin) {
            const groupFilterObject: any = groupFilter(this.$store.state.session.profile?.groupIds || []);
            this.forms = await this.formRepository.list({
                where: {
                    ...groupFilterObject
                },
                take: -1,
                order: {
                    orderIndex: 'asc',
                    createdAt: 'desc'
                }
            });
        }

        this.autoupdateDelay = this.isLive ? CommentsView.AUTOUPDATE_DELAY_LIVE : CommentsView.AUTOUPDATE_DELAY;

        if (this.useRealtimeUpdates) {
            this.commentsUpdateCallback = (data: any) => {
                try {
                    if (!Array.isArray(data)) {
                        return;
                    }

                    const update: CommentUpdateMessage[] = data.map(item => JSON.parse(item));
                    if (!this.isLoading) {
                        const filteredComments: CommentUpdate[] =
                            update.filter(this.filterFunc).map(item => item.data);
                        debug(`updated comments from hub: %O`, filteredComments);
                        this.onReceiveCommentsUpdates(filteredComments);
                    }

                    this.onBodyScroll();
                }
                catch (e) {
                    this.$store.dispatch('reportError', e);
                }
            }
            try {
                await this.realtimeRepository.attach(this.observer);
            }
            catch (e) {
                this.$store.dispatch('reportError', e);
            }
        } else {
            this.initRefresh(() => { this.do('REFRESH') }, this.autoupdateDelay);
        }
    }

    get observer() {
        const channelName = this.isMeeting ? `meeting.${this.objectId}.${this.lang}` : `object.${this.schemaId}.${this.objectId}.${this.lang}`;
        return {
            [channelName]: {
                [this.signalRMethod]: this.commentsUpdateCallback as RealtimeCallback
            }
        };
    }

    async mounted() {
        document.addEventListener("visibilitychange", this);
        this.do('LOAD');
        this.onUpdateAndMount()

        // remove 'hoverKey' prop for preventing add or remove hover class
        delete ((this.$refs.list as typeof DynamicScroller | undefined)?.$refs.scroller as typeof RecycleScroller | undefined)?.$data.hoverKey;
    }

    updated() {
        this.onUpdateAndMount()
    }

    async activated() {
        this.onUpdateAndMount();
    }

    deactivated () {
        document.removeEventListener("visibilitychange", this);
    }

    beforeDestroy () {
        document.removeEventListener("visibilitychange", this);
        if (this.useRealtimeUpdates) {
            try {
                this.realtimeRepository.detach(this.observer);
            }
            catch (e) {
                this.$store.dispatch('reportError', e);
            }
        }
    }

    setViewMode(mode: CommentViewModes, needSet: boolean) {
        this.viewMode = needSet ? mode : CommentViewModes.all
    }

    get commentsCount() {
        return this.comments?.length
    }

    // Vue computed fields
    get answerToUser(): string {
        return this.commentators[this.userIdToAnswer] ? this.commentators[this.userIdToAnswer].firstName + ',' : '';
    }

    get isAdmin() {
        return this.$store.getters['isAdmin'];
    }

    get filteredComments() {
        const comments: Comment[] = (this.comments || []).filter(this.commentsFilterFunction);
        if (this.viewMode === CommentViewModes.questions) {
            const questions = comments.filter(comment => comment.type === 'question' && !comment.isDeleted);
            questions.sort((a, b) => {
                if (a.likes.count > b.likes.count) {
                    return -1;
                } else if (a.likes.count < b.likes.count) {
                    return 1;
                }
                return this.commentsSorting(a, b);
            });
            return questions;
        } else if (this.viewMode === CommentViewModes.polls) {
            return comments
                .filter(comment => comment.text && comment.text.search(/forms:.*/gi) !== -1 || parseJson(comment.attachments)
                ?.find((item: CommentAttachment) => item.type === CommentAttachmentType.form))
                .sort(this.commentsSorting);
        }
        return comments.sort(this.commentsSorting);
    }

    get eventAdminGroups() {
        return this.$store.getters['services/getServiceParam']('eventsManagement', 'administratorGroupIds') || [];
    }

    get isLoading() {
        return !this.error && (this.commentStates?.state.value === 'loading' || this.commentStates?.state.value === 'init');
    }

    get isMeeting() {
        return this.schemaId === 'Meetings';
    }

    get isOnEditing() {
        return this.editedComment?.isOnEdit || false;
    }

    get signalRMethod() {
        return this.isMeeting ? SignalRMethod.meetingsCommentsUpdated : SignalRMethod.commentsUpdated;
    }

    get lang() {
        return this.$store.state.session?.language ?? 'en';
    }

    // возвращает фильтрующую функцию, которая проверяет пришедшие данные из хаба
    // если item не относится к просматриваемому пользователем событию/встрече, то он будет отфильтрован
    get filterFunc() {
        return (item: CommentUpdateMessage) => {
            return this.isMeeting
                ? item.objectId === this.objectId
                : item.objectId === this.objectId && item.schemaId === this.schemaId;
        }
    }

    // API calls
    private async fetchComments(query: CommentQueryParametersInterface) {
        return await this.commentRepository.query(this.schemaId, this.objectId, query);
    }

    private async getCommentUpdates() {
        return await this.commentRepository.updates(this.schemaId, this.objectId, this.lastUpdatedAt);
    }

    private async fetchСommentators(userIds: Array<number>) {
        const query = {
                where: {
                    userId: {
                        $in: userIds
                    }
                },
                include: ["id", "userId", "lastName", "firstName", "photoFileId", "groupIds"],
                take: -1
            };
        return await this.userRepository.profiles(query);
    }

    private async send() {
        let comment: Comment;

        if (this.isSending || !this.message || !this.$featureAccess.check("sendComment")) {
            return;
        }

        this.isSending = true;

        try {
            if (this.commentIdToAnswer) {
                comment = await this.commentRepository.sendCommentAnswer(this.schemaId, this.objectId, this.commentIdToAnswer, JSON.stringify(this.message));
                const commentIndex = this.comments.findIndex(item => item.id === (this.threadIdToAnswer ? this.threadIdToAnswer : this.commentIdToAnswer));
                if (this.comments[commentIndex].thread === null) {
                    const newBlock: CommentsBlock = new CommentsBlock({comments: [], nextCount: 0, previousCount: 0});
                    this.comments[commentIndex].thread = newBlock;
                }
                if (!this.useRealtimeUpdates) {
                    (this.comments[commentIndex].thread as CommentsBlock).comments.push(comment);
                }
            } else {
                comment = await this.commentRepository.sendComment(this.schemaId, this.objectId, this.message, this.isQuestion(this.message) ? 'question' : null);
                if (!this.useRealtimeUpdates) {
                    this.comments.push(comment);
                }
            }

            if (!this.useRealtimeUpdates && !this.commentators[comment.userId]) {
                const myProfile = await this.fetchСommentators([comment.userId]);
                this.updateCommentatorProfiles(myProfile);
            }

            this.message = '';
            this.commentIdToAnswer = '';
            this.threadIdToAnswer = '';
            this.userIdToAnswer = '';
            this.$nextTick(() => {
                const inputArea = this.$refs['inputArea'] as Vue;
                inputArea && (inputArea.$el as HTMLElement).focus();
                this.scrollToComment(comment);
            });

        } catch(e) {
            this.$store.dispatch('reportError', e);
        } finally {
            this.isSending = false;
        }
    }

    // Helpers
    private getUserIdsFromComments(comment: Comment): Array<number> {
        if (comment.thread) {
            return comment.thread.comments.map(item => item.userId).concat(comment.userId);
        }
        return [comment.userId];
    }

    private lastUpdatedComment(comments: Array<Comment>): Comment {
        return comments.reduce((result, current) => {
            let lastComment: Comment = current;
            if (current.thread) {
                lastComment = this.lastUpdatedComment(current.thread.comments);
                lastComment = lastComment.updatedAt > current.updatedAt ? lastComment : current;
            }
            return result.updatedAt > lastComment.updatedAt ? result : lastComment
        }, comments[0])
    }

    private getProfilesForThread(comment: Comment) {
        const userIds = [...new Set(this.getUserIdsFromComments(comment))],
            profiles: Record<string, UserProfile> = {};
        userIds.forEach(id => {
            if (this.commentators[id]) {
                profiles['' + id] = new UserProfile(this.commentators[id])
            }
        });
        return profiles;
    }

    private updateCommentatorProfiles(commentatorProfiles: UserProfile[] | UserProfileInterface[], checkExistence = false) {
        commentatorProfiles.forEach(profile => {
            if (checkExistence && this.commentators['' + profile.userId]) {return;}
            Vue.set(this.commentators, '' + profile.userId, new UserProfile(profile));
        });
    }

    // возвращает идентификаторы пользователей из переданного в параметре массива, которые еще не были загружены с бекенда
    private notLoadedUserProfiles(userIds: number[]) {
        const absentUserIds: number[] = [];
        userIds.forEach(id => {
            if (!this.commentators['' + id]) {
                absentUserIds.push(id);
            }
        });
        return absentUserIds;
    }

    // загружает профили пользователей, которых нет в массиве commentators компонента
    private async loadAbsentUserProfiles(userIds: number[]) {
        const absentUserIds = this.notLoadedUserProfiles([...new Set(userIds)]);

        if (absentUserIds.length) {
            this.updateCommentatorProfiles(await this.fetchСommentators(absentUserIds));
        }
    }

    // ищет комментарий в переданном массиве, если находит, то обновляет, в противном случае добавляет новый
    // возвращает true, если комментарий был найден и обновлен, false в противном случае
    findAndUpdateComment(array: Array<Comment>, comment: Comment) {
        let index = ArrayHelpers.findLastIndex(array, (value) => {
            return comment.createdAt > value.createdAt ||
                comment.id === value.id;
            }),
            result = false;

        if (index === -1) {
            index = 0;
            array.splice(0, 0, comment);
        } else {
            if (comment.id === array[index].id) {
                array[index].text = comment.text;
                array[index].isDeleted = comment.isDeleted;
                array[index].likes = comment.likes;
                array[index].updatedAt = comment.updatedAt;
                array[index].publishedAt = comment.publishedAt;
                array[index].isPinned = comment.isPinned;
                array[index].isPublished = comment.isPublished;
                result = true;
        } else {
                if (index === array.length - 1) {
                    array.push(comment);
                } else {
                    array.splice(index + 1, 0, comment);
                }
            }
        }
        return result;
    }

    // ищет комментарий в тредах переданного массива
    // если тред существует, то комментарий в треде обновляется или в тред добавляется новый, функция возвращает true
    // если тред не существует, то возвращается false
    findAndUpdateCommentInThreads(array: Array<Comment>, comment: Comment, needUpdateCounter = true) {
        const index = ArrayHelpers.findLastIndex(array, (value) => value.id === comment.threadId);
        if (index >= 0) {
            if (array[index].thread) {
                if (!this.findAndUpdateComment((array[index].thread as CommentsBlock).comments, comment) && needUpdateCounter) {
                    this.$emit('newComment', comment);
                }
            } else {
                array[index].thread = new CommentsBlock({ comments: [], nextCount: 0, previousCount: 0});
                (array[index].thread as CommentsBlock).comments.push(comment);
                if(needUpdateCounter) {
                    this.$emit('newComment', comment);
                }
            }
            return true;
        }
        return false;
    }

    deleteCommentFromFirstLevel(array: Array<Comment>, commentId: string): boolean {
        const index = ArrayHelpers.findLastIndex(array, (value) => {
            return commentId === value.id;
        });
        if (index !== -1) {
            array[index].delete();
            return true;
        }
        return false;
    }

    // обработка управляющих комментариев
    private processControlComment(comment: Comment) {
        if (this.isOrganizerComment(comment)) {
            const delay = Math.round(Math.random() * 5000);
            if ((comment.text.indexOf(CommentsView.CLOSE_LIVE_SESSION_MESSAGE) !== -1) && this.isLive) {
                setTimeout(() => {
                    this.$emit('closeLiveSession');
                }, delay);
            }
            if ((comment.text.indexOf(CommentsView.CHANGE_LIVE_SESSION_MESSAGE) !== -1) && this.isLive) {
                // После сообщения в скобках может быть идентификатор сессии, к которой нужно перейти
                // Если его нет - ищутся сессии текущего дня, дата начала которых больше now - 5 минут
                const r = comment.text.match(/\((.*?)\)/i);
                const uuid: string | undefined = r && r.length
                    ? r.slice(-1).pop()
                    : this.getNextSessionId()

                uuid && uuid !== this.objectId && setTimeout(() => {
                    this.$emit('changeLiveSession', uuid);
                }, delay);
            }
        }
    }

    private getNextSessionId(): string {
        const agenda: Element | undefined = this.$store.getters['program/nextSession'](this.objectId);
        return agenda?.id || ""
    }

    isQuestion(message: string) {
        return this.viewMode === CommentViewModes.questions || message.search(/.*\?+.*/gi) !== -1;
    }

    // обновление припиненого комментария
    // в массиве ищется комментарий с признаком isPinned = true и
    // если у него дата обновления больше чем у текущего припиненого, то он заменяет текущий
    private updatePinnedComment(comments: Comment[]) {
        let newPinnedComment: Comment | '' = this.pinnedComment;

        comments.forEach((comment: Comment) => {
            if (comment.isPinned && !comment.isDeleted) {
                if (!newPinnedComment || (newPinnedComment &&
                    (comment.updatedAt > newPinnedComment.updatedAt))) {
                    newPinnedComment = comment;
                }
            }
            if (newPinnedComment && !comment.isPinned && newPinnedComment.id === comment.id) {
                newPinnedComment = '';
            }
        });

        if (newPinnedComment) {
            newPinnedComment = newPinnedComment.cloneWithoutTread();
        }

        this.pinnedComment = newPinnedComment;
    }

    isOrganizerComment(comment: Comment) {
        return ArrayHelpers.intersect(this.eventAdminGroups, this.commentators[comment.userId]?.groupIds || []).length > 0;
    }

    private isControlComment(comment: Comment) {
        return comment.text
            && !comment.threadId
            && (comment.text.indexOf(CommentsView.CLOSE_LIVE_SESSION_MESSAGE) !== -1 || comment.text.indexOf(CommentsView.CHANGE_LIVE_SESSION_MESSAGE) !== -1);
    }

    // отправляет команду стейт-машине
    do(event: string) {
        this.commentStates?.send(event);
    }

    setError(value: boolean) {
        this.error = value;
    }

    /**
     * @comment комментарий до которого будет произведен скролл
     * @replyComment если есть, то нужно доскроллить до последнего ответа
     */
    @Debounce(300)
    async scrollToComment(comment: Comment, replyComment?: Comment) {
        let index = this.filteredComments.findIndex(item => item.id === comment.id);
        const dynamicScroller: (typeof DynamicScroller | undefined) = this.$refs['body'] || undefined;

        if(index < 0) {
            this.scrollToCommentReply(comment, dynamicScroller?.$el)
        }
        else if (index >= 0) {

            await this.scrollRecursively(comment.id, index)

            if(replyComment) {
                setTimeout(() => {
                    this.scrollToCommentReply(replyComment, dynamicScroller?.$el)
                }, 500)
            }
            else {
                this.highlightComment(comment);
            }
        }
    }

    /**
     * Recursively coz not all sizes is computed yet
     */
    async scrollRecursively(id: string, index?: number): Promise<void> {

        if(!index) {
            index = this.filteredComments.findIndex(item => item.id === id)
        }

        const dynamicScroller: typeof DynamicScroller = this.$refs['body'];
        const sizes = dynamicScroller?.vscrollData.sizes;

        return new Promise((resolve, _) => {

            if(!sizes || !Object.prototype.hasOwnProperty.call(sizes, id)) {
                dynamicScroller.scrollToItem(index)
                setTimeout(() => {
                    this.scrollRecursively(id, index);
                }, 400);
            }
            else {
                dynamicScroller.scrollToItem(index);
                resolve()
            }
        })
    }

    scrollToCommentReply(comment: Comment, body: HTMLElement) {
        const commentElement: HTMLElement | null = document.getElementById(`cid-${comment.id}`);
        const commentParentElement: HTMLElement | undefined | null = document.getElementById(`cid-${comment.threadId}`)?.parentElement?.parentElement?.parentElement;

        if (commentElement && commentParentElement) {
            const parentHeight = commentParentElement.clientHeight;
            const commentHeight = commentElement.clientHeight;
            const parentOffsetTop = getTranslateY(commentParentElement);

            //определение положение верхнего края родительского комментария
            const parentRelativeOffsetTop = parentOffsetTop - body.scrollTop;

            const offset = body.scrollTop + (parentRelativeOffsetTop + parentHeight - commentHeight);
            this.scrollCommentsTo(offset);
            this.highlightComment(comment);
        }
        else {
            //если целевые комментарии не отрендерены, то скролим до родительского комментария и подскроливаем до ответа
            let parentComment = this.filteredComments.find(item => item.id === comment.threadId);
            if(parentComment) {
                this.scrollToComment(parentComment, comment)
            }
        }
    }

    scrollCommentsToBottom() {
        const length = this.filteredComments.length
        if(length > 0) {
            const lastComment = this.filteredComments[length - 1];
            this.scrollRecursively(lastComment.id)
        }
    }

    scrollCommentsToTop() {
        (this.$refs['body'] as any).scrollToItem(0);
    }

    scrollCommentsTo(pixels: number, immediately = false) {
        const box = (this.$refs['body'] as any).$el as HTMLElement
        immediately && box.classList.remove("--smooth-scroll");
        box.scrollTop = pixels;
        immediately && box.classList.add("--smooth-scroll");
    }

    onUpdateAndMount() {
        this.$nextTick(function () {
            this.bodyResize()
        });
    }

    @Watch('viewFormLiveLeftSideHeight')
    bodyResize() {
        let decreaseAmount = 0;
        if(this.$refs['comments__header']) {
            const elHeight = (this.$refs['comments__header'] as HTMLElement).offsetHeight;
            decreaseAmount += elHeight;
        }

        // Устанавливается в false при отображении вкладок вне comments__header для управления участниками
        if (!this.isShowTitle) {
            decreaseAmount += 41;
        }

        const body = (this.$refs as any)?.body?.$el;
        if(detectMob()) {
            // const leftsideHeight = Math.round(this.viewFormLiveLeftSideHeight);
            // const windowHeight = window.innerHeight;
            // const ratio = leftsideHeight / windowHeight * 100;
            // const decreaseAmountRation = decreaseAmount / windowHeight * 100;

            // //если высота верхнего блока ниже чем 38vh, то body должен быть больше чем 62vh, иначе 62vh
            // const bodyHeight = ratio > 38 ? 62 : 100 - ratio - decreaseAmountRation;

            // this.$refs['body'] && ((this.$refs['body'] as HTMLElement).style.maxHeight = `${Math.round(bodyHeight).toString()}vh`);
        }
        else {
            body && body.style && (body.style.maxHeight = 'none');
        }

        body && body.style && (body.style.height = `calc(100% - ${decreaseAmount}px)`);
    }

    // предобработка комментария
    preprocessComment(comment: Comment) {
        const lang = this.$store.state.session.language;

        const attachments = parseJson(comment?.attachments) as CommentAttachment[];
        const localizedStrings = attachments?.find((item) => item.type === CommentAttachmentType.localizedStrings)?.strings;

        if(localizedStrings) {
            comment.text = localizedStrings[lang] ? localizedStrings[lang] : localizedStrings['en'];
        }

        return comment;
    }

    // Event handlers
    private async onGetPrevComments(obj: Record<string, string>) {
        const commentBlock = await this.fetchComments({ direction: 'Older', commentId: obj.commentId, threadId: obj.threadId }),
            commentIndex = this.comments.findIndex(item => item.id === obj.threadId),
            userIds = [...new Set(commentBlock.comments.map(item => item.userId))];

        this.loadAbsentUserProfiles(userIds);

        if (this.comments[commentIndex].thread !== null) {
            (this.comments[commentIndex].thread as CommentsBlock).previousCount = commentBlock.previousCount;
            (this.comments[commentIndex].thread as CommentsBlock).comments =
                commentBlock.comments.concat((this.comments[commentIndex].thread as CommentsBlock).comments);
        }
    }

    private onAnswer(obj: Record<string, string>) {
        const inputArea = this.$refs.inputArea as Vue;

        this.commentIdToAnswer = obj.commentId;
        this.threadIdToAnswer = obj.threadId;
        this.userIdToAnswer = obj.userId;

        (inputArea.$el as HTMLElement).focus();
    }

    private answerPanelClose() {
        this.threadIdToAnswer = '';
        this.commentIdToAnswer = '';
        this.userIdToAnswer = '';
    }

    private onLike(obj: Record<string, string | number | null>) {
        this.commentRepository.setLike(this.schemaId, this.objectId, obj.commentId as string, obj.value as number | null);
    }

    private async onDelete(item: { comment: Comment; isConfirmed: boolean }) {
        let confirmResult;

        if (this.pinnedComment && this.pinnedComment.id === item.comment.id) {
            const modal = new Modal({
                title: this.$t('common.warningTitle').toString(),
                contentText: this.$t('comments.pinnedDeletionError').toString(),
                buttons: [
                    {
                        text: this.$t('common.yes').toString(),
                        class: 'is-transparent-grey',
                        returnValue: true
                    }
                ]
            });

            await modal.showConfirm();

            return;
        }

        if (!item.isConfirmed) {
            const modal = new Modal({
                title: this.$t('comments.delete confirmation').toString(),
                buttons: [
                    {
                        text: this.$t('common.yes').toString(),
                        class: 'is-red',
                        returnValue: true
                    },
                    {
                        text: this.$t('common.cancel').toString(),
                        class: 'is-transparent-grey',
                        returnValue: false
                    },
                ]
            });

            confirmResult = await modal.showConfirm();
        }

        if (item.isConfirmed || confirmResult === true) {
            try {
                await this.commentRepository.delete(item.comment.id);
                if (!this.useRealtimeUpdates) {
                    this.deleteComment(item.comment.id);
                }
                // TODO: эмитить событие что-бы знать что комментов стало меньше
            } catch (e) {
                this.handleServerError(e);
            }
        }
    }

    private onEditStart(comment: Comment) {
        this.setEditedComment(comment);
    }

    private onCancelEdit(comment: Comment) {
        this.setEditedComment(null);
        this.scrollOnEdit(comment);
    }

    private async onEdit(comment: Comment, message: string) {
        const originMessage = comment.text;
        comment.text = message;

        try {
            await this.commentRepository.edit(comment.id, message);
            this.scrollOnEdit(comment);
        } catch (e) {
            comment.text = originMessage;
            this.handleServerError(e);
        }
    }

    private async onPublish(comment: Comment) {
        try {
            await this.commentRepository.publish(comment.id);
            // this.scrollOnEdit(comment);
        } catch (e) {
            this.handleServerError(e);
        }
    }

    setEditedComment(comment: Comment | null) {
        this.editedComment = comment;
    }

    private handleServerError(error: AxiosError) {
        let message = this.$t("common.errorTitle").toString();

        if(error.response?.data?.code) {
            message = this.$t(error.response?.data.code).toString();
        }
        else if(!error.response) {
            message = error.message;
        }

        new Popup({
            text: message,
            type: 'alert'
        });

        this.$store.dispatch('reportError', error);
    }

    private scrollOnEdit(comment: Comment) {
        const element: HTMLElement | null = this.getCommentElement(comment);
        if(element) {
            const croppedAtTop = (element.offsetTop - this.scrollState.top) < 0;
            const croppedAtBottom = element.offsetTop - this.scrollState.top + element.scrollHeight > this.scrollState.height;

            if(croppedAtTop || croppedAtBottom) {
                //если элемент находится за скролом или часть его находится за скролом
                this.scrollToComment(comment);
            }
            else {
                this.highlightComment(comment)
            }
        }
    }

    private async onPin(comment: Comment) {
        if (this.isChangingPinnedComment) {
            return
        }

        this.isChangingPinnedComment = true;
        try {
            if (comment.isPinned) {
                await this.commentRepository.unpin(comment.id);
            } else {
                this.pinnedComment && await this.commentRepository.unpin(this.pinnedComment.id);
                await this.commentRepository.pin(comment.id);
            }
            if (!this.useRealtimeUpdates) {
                this.do('REFRESH');
                this.setRefreshFn(() => { this.do('REFRESH') }, this.autoupdateDelay);
            }
        } catch (e) {
            this.$store.dispatch('reportError', e);
        } finally {
            this.isChangingPinnedComment = false;
        }
    }

    private onAttachClicked() {
        if (!this.isAdmin || !this.forms?.length) {
            return;
        }

        if (this.isShowAnswerPanel) {
            this.commentIdToAnswer = '';
        }

        this.isShowPollsPanel = !this.isShowPollsPanel;
    }

    private onShowUserProfile(userProfile: UserProfile) {
        this.$emit('show-user-profile', userProfile);
    }

    // обновление комментариев, пришедших в realtime режиме
    private async onReceiveCommentsUpdates(commentUpdates: CommentUpdate[]) {
        const {profiles, comments} = parseCommentUpdates(commentUpdates);

        if (profiles && profiles.length) {
            this.updateCommentatorProfiles(profiles, true);
        }

        //если в списке есть запиненный комментарий или если текущий запиненный комментарий совпадает с пришедшим и он не запинен
        const needToUpdatePinned = comments.findIndex(item =>
            item.isPinned || (typeof this.pinnedComment !== "string" && item.id === this.pinnedComment.id && !item.isPinned)
        ) >= 0;

        comments.forEach(comment => {
            if (this.isControlComment(comment)) {
                this.processControlComment(comment);
            } else if (comment.isDeleted) {
                this.deleteComment(comment.id);
            } else if (!comment.threadId) {
                if (!this.findAndUpdateComment(this.comments, this.preprocessComment(comment))) {
                    this.commentsFilterFunction(comment) && this.$emit('newComment', comment);
                }
            } else {
                this.findAndUpdateCommentInThreads(this.comments, comment);
                this.autoScrollComments();
            }
            needToUpdatePinned && this.updatePinnedComment(comments);
        });
    }

    // обновление комментариев, полученных периодическим запросом к бекенду
    private async refreshComments() {
        try {
            const updatedComments = await this.getCommentUpdates();

            if (updatedComments.updated && updatedComments.updated.length) {
                const userIds: number[] = updatedComments.updated.map((comment: Comment) => comment.userId),
                    commentsInThreads = updatedComments.updated.filter((comment: Comment) => comment.threadId),
                    commentsNotInThreads = updatedComments.updated.filter((comment: Comment) => !comment.threadId),
                    controlComments: Comment[] = [];

                commentsNotInThreads.forEach((comment: Comment) => {
                    if (this.isControlComment(comment)) {
                        controlComments.push(comment);
                    } else {
                        this.findAndUpdateComment(this.comments, this.preprocessComment(comment));
                    }
                })

                this.updatePinnedComment(commentsNotInThreads);

                commentsInThreads.forEach((comment: Comment) => {
                    if (this.findAndUpdateCommentInThreads(this.comments, comment, false)) {
                        userIds.push(comment.userId);
                    }
                })

                this.loadAbsentUserProfiles(userIds);

                if (controlComments.length) {
                    controlComments.forEach(comment => {
                        this.processControlComment(comment);
                    })
                }
            }

            if (updatedComments?.deleted?.length) {
                if (this.pinnedComment) {
                    if (updatedComments.deleted.indexOf(this.pinnedComment.id) !== -1) {
                        this.pinnedComment = '';
                    }
                }
                updatedComments.deleted.forEach((commentId: string) => {
                    this.deleteComment(commentId);
                })
            }
            this.lastUpdatedAt = updatedComments.updatedAt;
        } catch (err) {
            this.$store.dispatch('reportException', err, {root: true});
            return Promise.reject();
        }
    }

    // удаление комментария по его идентификатору
    deleteComment(commentId: string) {
        if (!this.deleteCommentFromFirstLevel(this.comments, commentId)) {
            this.comments.some(comment => {
                if (comment.thread) {
                    return this.deleteCommentFromFirstLevel((comment.thread as CommentsBlock).comments, commentId)
                }
                return false;
            })
        }
    }

    async handleEvent(event: Event) {
        if (event.type === 'visibilitychange') {
            if (!document.hidden) {
                this.refreshComments()
            }
        }
    }

    async selectForm(form: Form) {

        const attachments = [
            {
                type: CommentAttachmentType.form,
                id: form.id
            }
        ];

        const comment = await this.commentRepository.sendComment(this.schemaId, this.objectId, form.title || this.$t('comments.polls')?.toString(), null, attachments);
        if (!this.useRealtimeUpdates) {
            this.comments.push(comment);
        }
        this.$nextTick(() => {
            const element: HTMLElement  = document.getElementById(`cid-${comment.id}`) as HTMLElement;
            element.scrollIntoView({ behavior: 'smooth' });
        })

    }

    @Watch('viewMode')
    private onSwitchTab() {
        this.answerPanelClose();
        if (this.viewMode === CommentViewModes.polls) {
            this.isShowAnswerPanel = false;
        } else {
            this.isShowAnswerPanel = true;
        }

        if (this.isLive && this.viewMode === CommentViewModes.all) {
            // Если до переключения вкладок мы пролистали вверх, то нужно сохранить это положение
            if (this.scrollState.needScrollBottom) {
                this.$nextTick(() => {
                    this.scrollCommentsToBottom();
                })
            } else {
                this.$nextTick(() => {
                    this.scrollCommentsTo(this.scrollState.top, true);
                })
            }
        }
        if (this.isLive && this.viewMode === CommentViewModes.questions) {
            this.$nextTick(() => {
                this.scrollCommentsToTop();
            })
        }

        if(this.editedComment) {
            this.editedComment.isOnEdit = false;
        }
    }

    private highlightComment(comment: Comment) {
        const element: HTMLElement | null = this.getCommentElement(comment);
        if(element) {
            element.classList.add('comment_selected');
            setTimeout(() => { element.classList.remove('comment_selected') }, 1500);
        }
    }

    private getCommentElement(comment: Comment): HTMLElement | null {
        return document.getElementById(`cid-${comment.id}`);
    }

    @Watch('commentIdToAnswer')
    private showPanel(newCommentIdToAnswer: string) {
        if (!this.isShowAnswerPanel && newCommentIdToAnswer) {
            this.isShowAnswerPanel = true;
        } else if (!newCommentIdToAnswer && this.viewMode === CommentViewModes.polls) {
            this.isShowAnswerPanel = false;
        }
    }

    onBodyScroll() {
        if (this.viewMode !== CommentViewModes.all) { return }

        const body = (this.$refs['body'] as Vue)
        const box = body.$el as HTMLElement;

        if(box) {
            const height = box.clientHeight;
            const top = box.scrollTop;
            const state = this.scrollState
            const lastTop = state.top;
            const totalSize = (body.$refs.scroller as any).totalSize;

            if (top < lastTop) {
                state.scrolledUp += lastTop - top
            } else if (state.scrolledUp > 0) {
                state.scrolledUp -= top - lastTop
            }

            state.height = height;
            state.top = top
            state.needScrollBottom = top + height + CommentsView.MIN_OFFSET_FOR_AUTOSCROLLING > totalSize
        }
    }

    @Watch('filteredComments')
    @Debounce(500)
    autoScrollComments() {
        if (this.scrollState.needScrollBottom && this.viewMode === CommentViewModes.all) {
            this.scrollCommentsToBottom();
        }
    }

    sortingValue(comment: Comment) {
        return commentSortingValue(comment, this.isAdmin, this.$store.state.session.userId);
    }

    commentsSorting(a: Comment, b: Comment) {
        const aValue = this.sortingValue(a);
        const bValue = this.sortingValue(b);

        if (aValue < bValue) {
            return -1;
        }
        if (aValue > bValue) {
            return 1;
        }

        return 0;
    }

    commentsFilterFunction(item: Comment) {
        return this.isAdmin
            || isCommentPublished(item.isPublished) && (!this.filterByUsers.length || this.filterByUsers.length && (this.filterByUsers.indexOf(item.userId) !== -1))
            || item.userId === this.$store.state.session.userId;
    }
}
